import { useQuery } from '@tanstack/react-query';
import { analyticsApi } from '@api/analyticsApi';

export function useOwnerDashboard() {
  return useQuery({
    queryKey: ['analytics', 'owner-dashboard'],
    queryFn: () => analyticsApi.getOwnerDashboard(),
    refetchInterval: 5 * 60 * 1000,
  });
}

export function useSalesTrend(acqMonths = 6) {
  return useQuery({
    queryKey: ['analytics', 'sales-trend', acqMonths],
    queryFn: () => analyticsApi.getSalesTrend(acqMonths),
    refetchInterval: 5 * 60 * 1000,
  });
}

export function useRecentOperations(acqLimit = 10) {
  return useQuery({
    queryKey: ['analytics', 'recent-operations', acqLimit],
    queryFn: () => analyticsApi.getRecentOperations(acqLimit),
    refetchInterval: 60 * 1000, // частіше для feed-у
  });
}
